(function () {
  // 綁定縮略圖區域的滑鼠滾輪事件（只在 thumbs_aside 模式 + 桌面端）
  function bindThumbWheel(root) {
    if (!root) {
      root = document;
    }

    // 只在桌面端啟用
    if (window.innerWidth < 990) return;

    // 只選 thumbs_aside 這種佈局下的縮略圖 swiper
    var thumbLists = root.querySelectorAll(
      '.product__outer--thumbs-aside .product__media-sublist.swiper, ' +
      '.product__gallery--thumbs_aside-mobile .product__media-sublist.swiper'
    );

    thumbLists.forEach(function (thumbEl) {
      // 防止重複綁定
      if (thumbEl.dataset.wheelBound === 'true') return;
      thumbEl.dataset.wheelBound = 'true';

      thumbEl.addEventListener(
        'wheel',
        function (event) {
          // 若縮到手機寬，就不處理
          if (window.innerWidth < 990) return;

          var currentEl = event.currentTarget;
          var swiper = currentEl && currentEl.swiper;
          if (!swiper) return;

          // 主要針對垂直滾動
          if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
            return;
          }

          if (event.deltaY > 0) {
            // 向下滾：看更多下面的縮略圖
            if (!swiper.isEnd) {
              event.preventDefault(); // 攔住頁面滾動
              swiper.slideNext();
            }
          } else if (event.deltaY < 0) {
            // 向上滾：回到上面的縮略圖
            if (!swiper.isBeginning) {
              event.preventDefault();
              swiper.slidePrev();
            }
          }
          // 如果已經在頂/底，讓事件自然冒泡，不攔截，頁面照常滾動
        },
        { passive: false }
      );
    });
  }

  // 綁定大圖區域的滑鼠移入放大 & 跟隨滑動（PC）
  function bindMainImageZoom(root) {
    if (!root) {
      root = document;
    }

    // 只在桌面端啟用
    if (window.innerWidth < 990) return;

    // 只處理主圖列表中的每一張大圖
    var mainItems = root.querySelectorAll('.product__media-list .product__media-item');

    mainItems.forEach(function (item) {
      // 防止重複綁定
      if (item.dataset.zoomBound === 'true') return;
      item.dataset.zoomBound = 'true';

      var img = item.querySelector('img');
      if (!img) return; // 沒有圖片的不處理（視頻 / 模型等）

      // 確保容器裁剪放大後溢出的部分
      if (!item.style.overflow) {
        item.style.overflow = 'hidden';
      }

      function onEnter(e) {
        if (window.innerWidth < 990) return;

        item.classList.add('is-zoomed');

        // 開啟 2 倍放大
        img.style.transition = 'transform 0.15s ease-out';
        img.style.transform = 'scale(2.5)';
        img.style.transformOrigin = 'center center';
      }

      function onMove(e) {
        if (!item.classList.contains('is-zoomed')) return;
        if (window.innerWidth < 990) return;

        var rect = item.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;

        // 限制在 0-100 之間，避免極端情況
        if (x < 0) x = 0;
        if (x > 100) x = 100;
        if (y < 0) y = 0;
        if (y > 100) y = 100;

        img.style.transformOrigin = x + '% ' + y + '%';
      }

      function onLeave() {
        item.classList.remove('is-zoomed');
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = 'center center';
      }

      item.addEventListener('mouseenter', onEnter);
      item.addEventListener('mousemove', onMove);
      item.addEventListener('mouseleave', onLeave);
    });
  }

  function swiperInit() {
    // 原本的初始化邏輯
    subSliderInit(true);
    sliderInit(true);
    popupSliderInit(true);

    // 初始化完成後，給當前頁面上的縮略圖綁定滾輪
    bindThumbWheel(document);
    // 給主圖綁定 hover 放大
    bindMainImageZoom(document);
  }

  // Shopify 在編輯器裡重載 section 時也要重新綁定
  document.addEventListener('shopify:section:load', function (e) {
    swiperInit();
    if (e && e.target) {
      bindThumbWheel(e.target);
      bindMainImageZoom(e.target);
    }
  });

  // 首次頁面載入
  swiperInit();
})();
